@for (grid of profitabilityModel(); track $index) {
	<div class="grid grid-cols-{{ columns() }} gap-3 text-center w-full">
		@for (row of grid; track $index) {
			@for (cell of row; track $index) {
				@if ($index < columns()) {
					@if (cell) {
						<ng-container
							*ngTemplateOutlet="
								cellTemplate;
								context: {
									type: cell.type,
									value: cell.value,
									last: $last,
								}
							"
						/>
					} @else {
						<!-- blank space to take up with null spot -->
						<div></div>
					}
				}
			}
		}
	</div>

	@if (!$last) {
		<div class="mar-divider"></div>
	}
}

<ng-template #cellTemplate let-value="value" let-type="type" let-last="$last">
	@if (type === 'header') {
		<div
			class="bg-accent text-sm px-3 rounded-lg h-14 flex justify-center items-center"
		>
			@if (loading()) {
				<p [tuiSkeleton]="2"></p>
			} @else {
				<p
					class="text-primary font-semibold"
					[innerText]="
						value | transloco: { symbol: currencySymbol() }
					"
				></p>
			}
		</div>
	} @else {
		<div
			class="px-3 rounded-lg text-sm flex justify-center items-center h-14"
			[class.bg-white]="type === 'dollar'"
			[class.bg-primary-light-700]="type === 'total'"
		>
			@if (loading()) {
				<p [tuiSkeleton]="2"></p>
			} @else if (type === 'total' && ('material' | isCostType)) {
				<p class="text-gray-600">—</p>
			} @else {
				<p
					[class.font-semibold]="last || type === 'total'"
					[innerText]="value | centsToDollars: { round: true }"
				></p>
			}
		</div>
	}
</ng-template>
